import { Component, ViewContainerRef } from '@angular/core';
import { SageSettingsService } from './sage-settings.service';
import { SageSettingsStore } from './sage-settings.store';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '../../shared/services/config.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AccountSetupDialogComponent } from '../account-setup-dialog/account-setup-dialog.component';
import { ConfirmDialogComponent } from '../../shared';
import { INTEGRATION_IJ } from '../account-setup-dialog/account-setup-dialog.store';
import { MatButton } from '@angular/material/button';
import { NgIf, AsyncPipe, TitleCasePipe } from '@angular/common';
import { KeyValuePairComponent } from '../../shared/general/key-value-pair/key-value-pair.component';

@Component({
    selector: 'sage-setup',
    templateUrl: './sage-setup.component.html',
    providers: [
        SageSettingsService,
        SageSettingsStore,
        { provide: INTEGRATION_IJ, useValue: 'sage' }
    ],
    standalone: true,
    imports: [KeyValuePairComponent, NgIf, MatButton, AsyncPipe, TitleCasePipe]
})
export class SageSetupComponent {
  status$ = this.store.status$;
  loading$ = this.store.loading$;

  constructor(
    private router: Router,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private store: SageSettingsStore,
    private dialog: MatDialog,
    private toastService: ToastrService,
    private vcr: ViewContainerRef
  ) {}

  attemptConnection() {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Connect Sage',
        type: 'close',
        message:
          'To connect your Sage account to HireLogic please contact support'
      }
    });
  }

  openAccountSetupDialog() {
    this.dialog.open(AccountSetupDialogComponent, {
      viewContainerRef: this.vcr
    });
  }

  disconnectConfirm() {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Disconnect Sage',
        type: 'close',
        message:
          'To disconnect your Sage account from HireLogic please contact support'
      }
    });
  }

  importCustomers() {
    this.store.importCustomers();
  }
}
